import { createContext } from "react";
import AuthService from "./models/AuthService";

export const AuthServiceContext = createContext<AuthService | null>(null);
